import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const JoyrideModule = require("react-joyride");
// react-joyride v2 utilise export = donc le module peut être default ou le module lui-même
const Joyride = JoyrideModule.default || JoyrideModule;
import { useFormation } from "./FormationContext";
import { getTutorielById } from "./tutoriels";
// Constantes Joyride (remplace les STATUS/ACTIONS du package)
const STATUS_FINISHED = "finished";
const STATUS_SKIPPED = "skipped";
const ACTION_NEXT = "next";
const ACTION_PREV = "prev";
/**
 * Composant qui monte react-joyride quand un tutoriel est actif.
 * Gère le cycle de vie : démarrage, sauvegarde des steps, fin.
 */
export const TourGuide = () => {
    const { activeTutoriel, stopTutoriel, saveStep } = useFormation();
    const [run, setRun] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const tutoriel = activeTutoriel ? getTutorielById(activeTutoriel) : null;
    useEffect(() => {
        if (tutoriel) {
            setStepIndex(0);
            setTimeout(() => setRun(true), 300);
        }
        else {
            setRun(false);
        }
    }, [tutoriel]);
    if (!tutoriel)
        return null;
    const handleCallback = (data) => {
        const { status, index, action, type } = data;
        if (type === "step:after" && action === ACTION_NEXT) {
            saveStep(index);
            setStepIndex(index + 1);
        }
        if (type === "step:after" && action === ACTION_PREV) {
            setStepIndex(Math.max(0, index - 1));
        }
        if (status === STATUS_FINISHED) {
            setRun(false);
            stopTutoriel(true);
        }
        else if (status === STATUS_SKIPPED) {
            setRun(false);
            stopTutoriel(false);
        }
    };
    return (_jsx(Joyride, { steps: tutoriel.steps, run: run, stepIndex: stepIndex, continuous: true, showProgress: true, showSkipButton: true, scrollToFirstStep: true, disableOverlayClose: true, spotlightClicks: false, callback: handleCallback, locale: {
            back: "Précédent",
            close: "Fermer",
            last: "Terminer",
            next: "Suivant",
            skip: "Passer",
            open: "Ouvrir le tutoriel",
        }, styles: {
            options: {
                primaryColor: "#0078d4",
                zIndex: 10000,
                textColor: "#1f2937",
                backgroundColor: "#ffffff",
                overlayColor: "rgba(0, 0, 0, 0.5)",
                arrowColor: "#ffffff",
                width: 400,
            },
            tooltipTitle: {
                fontSize: 18,
                fontWeight: 600,
                margin: "0 0 12px 0",
                color: "#0078d4",
            },
            tooltipContent: {
                fontSize: 14,
                lineHeight: 1.5,
                padding: "0",
            },
            buttonNext: {
                backgroundColor: "#0078d4",
                borderRadius: 4,
                fontSize: 14,
                fontWeight: 600,
                padding: "8px 16px",
            },
            buttonBack: {
                color: "#6b7280",
                fontSize: 14,
                marginRight: 8,
            },
            buttonSkip: {
                color: "#9ca3af",
                fontSize: 13,
            },
        } }));
};
